import { types } from "../action-types";
import { getCookie } from "../../shared/helpers";

const token = getCookie("token");
const impersonationId = getCookie("impersonationid");

// import initialState from './appReducer'; 
const initialState = {
  url: false,
  loading: false,
  user: {
    authToken: token ? token : null,
  },
  impersonationId: impersonationId ? impersonationId : null,
  error: {},
  notLogged: false,
  emailCheck: false,
  signUpLogin: true,
  isModalVisibleAuth: false,
};

const authReducer = (state = initialState, action) => {
  // debugger;
  switch (action.type) {
    case types.IS_MODAL_VISIBLE:
      return {
        ...state,
        isModalVisibleAuth: action.payload,
      };

    case types.SIGNUP_LOGIN_UPDATE:
      return {
        ...state,
        signUpLogin: action.payload,
      };

    case types.EMAIL_FLOW_UPDATE:
      return {
        ...state,
        emailCheck: action.payload,
      };

    case types.UPDATE_USER_INFO_SUCCESS:
      // debugger;
      return {
        ...state,
        loading: false,
        user: { ...state.user, authToken: action.payload },
        error: {},
      };
    case types.LINKEDIN_TOKEN_FAIL:
      return {
        ...state,
        loading: false,
        user: {},
        error: action.error,
        notLogged: true,
      };
    case types.SEND_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        user: {},
        error: action.error,
      };
    case types.UPDATE_IMPERSONATION_ID:
      return {
        ...state,
        loading: false,
        impersonationId: action.payload,
      };
    case types.GET_PROFILE_URL:
      return {
        ...state,
        url: true,
      };
    default:
      return state;
  }
};

export default authReducer;
